import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.5 1H3.5C3.10218 1 2.72064 1.1475 2.43934 1.41005C2.15804 1.6726 2 2.0287 2 2.4V13.6C2 13.9713 2.15804 14.3274 2.43934 14.5899C2.72064 14.8525 3.10218 15 3.5 15H12.5C12.8978 15 13.2794 14.8525 13.5607 14.5899C13.842 14.3274 14 13.9713 14 13.6V5.2M9.5 1L14 5.2M9.5 1V5.2H14M11 8.7H5M11 11.5H5M6.5 5.9H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;